module.exports = __webpack_public_path__ + "./images/csv-thumbnail.751d71.jpg";